






export default {
  name: 'search-box',
  data() {
    return {
      timedOut: false
    }
  },
  mounted() {
    window.setTimeout(() => {
      this.timedOut = true
      if (this.lastArticle !== false) {
        this.$store.dispatch('news/setRead', this.lastArticle.id)
      }
    }, 10000)
  },
  methods: {
    openNews({ url, id }) {
      window.openLink(url)
      this.$store.dispatch('news/setRead', id)
    }
  },
  computed: {
    somethingNew() {
      return this.unreadNewsCount > 0
    },
    visible() {
      return this.somethingNew && !this.timedOut
    },
    unreadNewsCount() {
      return this.$store.getters['news/unreadCount']
    },
    lastArticle() {
      const articles = this.$store.getters['news/unreadArticles']
      return articles.length > 0 ? articles[Math.floor(Math.random() * articles.length)] : false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/notification.vue